export default function CTABannerSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[540px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20gradient%20composition%20with%20warm%20coral%20orange%20and%20dark%20charcoal%20tones%2C%20smooth%20curved%20waves%20with%20soft%20texture%2C%20modern%20minimal%20illustration%20style%2C%20dramatic%20contrast%20between%20warm%20and%20dark%20areas%2C%20cinematic%20atmospheric%20lighting%2C%20no%20text%2C%20abstract%20art%20composition&width=1800&height=700&seq=cta-banner-bg&orientation=landscape"
        alt="歪歪漫画"
        className="absolute inset-0 w-full h-full object-cover"
        title="歪歪漫画网 - 立即开始阅读"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/50 via-primary-950/30 to-transparent"></div>

      <div className="relative z-10 w-full h-full px-4 md:px-10 flex items-center">
        <div className="max-w-6xl mx-auto w-full">
          <div className="md:max-w-lg">
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight">
              现在就加入
              <br />
              歪歪漫画
            </h2>
            <p className="mt-4 md:mt-5 text-sm md:text-base text-background-50/80 leading-relaxed max-w-md">
              韩漫无删减资源每日更新，网红吃瓜全网首发，
              一键进入不迷路
            </p>
            <div className="mt-6 md:mt-8">
              <a
                href="#hot"
                className="inline-flex items-center gap-3 px-7 py-3.5 rounded-full bg-background-50 text-primary-900 text-sm md:text-base font-semibold hover:bg-background-100 transition-colors duration-200 cursor-pointer group"
              >
                立即免费阅读
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-background-50 group-hover:bg-accent-600 transition-colors duration-200">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}